<template>
  <svg
    width="20"
    height="12"
    fill="none"
    viewBox="0 0 20 12"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="currentColor"
      d="M17.4331 0.464071C17.716 0.166774 18.098 4.65915e-07 18.4961 5.18118e-07C18.8942 5.7032e-07 19.2761 0.166774 19.559 0.464071C19.6987 0.610059 19.8096 0.784075 19.8853 0.975991C19.961 1.16791 20 1.37389 20 1.58194C20 1.79 19.961 1.99598 19.8853 2.1879C19.8096 2.37981 19.6987 2.55383 19.559 2.69982L11.064 11.5367C10.7805 11.8336 10.3983 12 10 12C9.60173 12 9.21947 11.8335 8.93595 11.5367L0.440972 2.69981C0.30131 2.55383 0.190399 2.37981 0.114693 2.18789C0.038988 1.99598 1.33888e-06 1.79 1.36616e-06 1.58194C1.39345e-06 1.37388 0.0389881 1.1679 0.114693 0.975988C0.190399 0.784073 0.30131 0.610057 0.440973 0.464068C0.723851 0.166772 1.10585 -1.76233e-06 1.50393 -1.71013e-06C1.90202 -1.65793e-06 2.28401 0.166772 2.56689 0.464069L10.0033 7.71121L17.4331 0.464071Z"
    />
  </svg>
</template>
